module.exports = __webpack_public_path__ + "static/media/box.65e396d2.svg";